import { ValidationRules } from '../enums';

export const getValidationMessageByRule = (ruleCode, value) => {
    switch (ruleCode) {
        case ValidationRules.IS_NUMERIC:
            return 'Attribute value must be numeric';
        case ValidationRules.MINIMUM_VALUE:
            return `Minimum value of attribute is ${value}`;
        case ValidationRules.MAXIMUM_VALUE:
            return `Maximum value of attribute cannot exceed  ${value}`;
        case ValidationRules.MINIMUM_LENGTH:
            return `Minimum length of attribute is ${value} characters`;
        case ValidationRules.MAXIMUM_LENGTH:
            return `Maximum length of attribute cannot exceed ${value} characters`;
    }
};
